<template>
  <div id="addVictim">
    <b-row>
      <b-col>
        <label for="burialType"
          >{{ $t("avalanche.label.damage.burialType") }}
        </label>
        <b-form-select
          id="burialType"
          v-model="victim.burialType"
          :options="burialType"
          @change="handleBurialTypeChange"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div v-if="victim.burialType && victim.burialType === 'COMPLETE'">
          <label for="burialDepth"
            >{{ $t("avalanche.label.damage.burialDepth") }}
          </label>
          <b-form-input
            id="burialDepth"
            v-model="victim.burialDepth"
            type="number"
            min="0"
            max="10000"
            step="1"
            pattern="[0-9]*"
            :placeholder="$t('common.unit.centimeter')"
          ></b-form-input>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div v-if="victim.burialType && victim.burialType === 'COMPLETE'">
          <label for="burialPeriod"
            >{{ $t("avalanche.label.damage.burialPeriod") }}
          </label>
          <input
            class="form-control"
            id="burialPeriod"
            v-model="victim.burialPeriod"
            type="number"
            min="0"
            max="10000"
            step="1"
            pattern="[0-9]*"
            :placeholder="$t('common.unit.minute')"
          />
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <label for="personDamageType"
          >{{ $t("avalanche.label.damage.personDamageType") }}
        </label>
        <b-form-select
          id="personDamageType"
          v-model="victim.personDamageType"
          :options="personDamageType"
        />
      </b-col>
    </b-row>
    <div style="margin-top: 20px; text-align: center">
      <b-button id="addVcitim" @click="addVictim"> OK </b-button>
    </div>
  </div>
</template>

<script>
import { i18nMixin } from "@/I18N";
import store from "@/store/store.js";

export default {
  name: "AvalancheVictim",
  data() {
    return {
      victim: {
        personDamageType: null,
        burialType: null,
        burialPeriod: null,
        burialDepth: null,
      },
    };
  },
  mixins: [i18nMixin],
  computed: {
    burialType() {
      return this.options("avalanche", "burialType");
    },
    personDamageType() {
      return this.options("avalanche", "personDamageType");
    },
  },
  methods: {
    addVictim() {
      store.AvalancheData.addVictim(this.victim);
      this.$emit("victimAdded");
    },
    handleBurialTypeChange() {
      if (this.victim.burialType !== "COMPLETE") {
        this.victim.burialDepth = null;
        this.victim.burialPeriod = null;
      }
    },
  },
};
</script>

<style></style>
